import React from 'react';

/**
 * Form field wrapper: an uppercase label above the control and an optional
 * hint below it. The control itself is passed as children.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.label - Uppercase field label.
 * @param {React.ReactNode} [props.hint] - Optional helper text shown below.
 * @param {string} [props.htmlFor] - Associates the label with a control id.
 * @param {React.ReactNode} props.children - The input/control.
 * @param {string} [props.className] - Extra classes on the wrapper.
 * @returns {JSX.Element}
 */
export default function FormField({ label, hint, htmlFor, children, className = '' }) {
  return (
    <div className={className}>
      <label
        htmlFor={htmlFor}
        className="block text-[12px] uppercase tracking-wider font-bold text-gray-500 mb-1.5"
      >
        {label}
      </label>
      {children}
      {hint && <p className="text-[11.5px] text-gray-400 mt-1">{hint}</p>}
    </div>
  );
}
